/**
 * Created by hj on 2017/8/17.
 */
import React from 'react';
import { DmsTab } from 'Components';
import { Button, Modal, Input, Switch } from 'antd';
import { openNotice, config } from 'Utils';
import { getInvoiceDetail, getInvoiceApprove, getAccountDetail } from '../../service/home';
import { accountAudit } from '../../service/account';

class returnOrderDetail extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			visibleApprove: false,
			loadingApprove: false,
			detailData: {},
			approveData: {
				auditOpinion: 1,
				auditRemark: ''
			}
		}
	}

	openImg (path) {
		window.open(path);
	}

	showApproveModal () {
		this.setState({
			'visibleApprove': true,
			'approveData': {
				...this.state.approveData,
				'auditOpinion': 1,
				'auditRemark': ''
			}
		});
	}
	handleApproveOk () {
		let self = this;
		self.setState({loadingApprove: true});
		let approveData = self.state.approveData;
		let routeParams = this.props.routeParams;
		if (routeParams.entityType == 8) {
			// 增票审核
			let params = {
				'id': routeParams.entityId,
				'remark': approveData.auditRemark,
				'status': approveData.auditOpinion ? 2: 3
			};
			getInvoiceApprove(params).then(function (result) {
				if (result && result.code == 200) {
					self.setState({
						loadingApprove: false,
						visibleApprove: false
					});
					self.initData();
				} else {
					self.setState({loadingApprove: false});
					openNotice('error', '数据获取失败', (result && result.message) ? result.message : '');
				}
			});
		} else if (routeParams.entityType == 7) {
			// 账号审核
			approveData.auditOpinion = approveData.auditOpinion ? 1 : 0;
			accountAudit({...approveData, id: routeParams.entityId}).then(function (result) {
				if (result && result.code == 200) {
					self.setState({
						loadingApprove: false,
						visibleApprove: false
					});
					self.initData();
				} else {
					self.setState({loadingApprove: false});
					openNotice('error', '数据获取失败', (result && result.message) ? result.message : '');
				}
			});
		}
	}
	handleApproveCancel () {
		this.setState({
			'visibleApprove': false,
			'loadingApprove': false
		});
	}
	changeApproveFn (field, value) {
		this.setState({
			'approveData': {
				...this.state.approveData,
				[field]: typeof value == 'object' ? value.target.value : value
			}
		});
	}

	initData () {
		let routeParams = this.props.routeParams;
		let self = this;
		if (routeParams.entityType == 8) {
			// 增票审核
			getInvoiceDetail(routeParams.entityId).then(function (result) {
				if (result && result.code == 200) {
					self.setState({
						'detailData': result.data || {}
					});
				} else {
					openNotice('error', '数据获取失败', (result && result.message) ? result.message : '');
				}
			});
		} else if (routeParams.entityType == 7) {
			// 账号审核
			getAccountDetail(routeParams.entityId).then(result => {
				if (result && result.code == 200) {
					self.setState({
						'detailData': result.data || {}
					});
				} else {
					openNotice('error', '数据获取失败', (result && result.message) ? result.message : '');
				}
			});
		}
	}

	componentDidMount () {
		this.initData();
	}

	backTo() {
		window.history.go(-1);
	}

	render() {
		const { detailData, visibleApprove, loadingApprove, approveData } = this.state;
		let self = this;
		let routeParams = self.props.routeParams;
		let detailHtml = function () {
			if (routeParams.entityType == 8) {
				let approveHtml = function () {
					if (detailData.status != 1) {
						return (
							<div>
								<DmsTab className="white-bg no-border" options={['审核信息']} defaultKey={0}></DmsTab>
								<div className="tax_detail">
									<div className="com_detail">
										<div>
											<p><label>申请人</label><span>{detailData.userName}</span></p>
											<p><label>审核人</label><span>{detailData.approveName}</span></p>
											<p><label>审核意见</label><span>{detailData.auditOpinion}</span></p>
										</div>
										<div>
											<p><label>申请时间</label><span>{detailData.createdDate}</span></p>
											<p><label>审核时间</label><span>{detailData.approveDate || detailData.rejectDate}</span></p>
											<p><label>备注</label><span>{detailData.remark}</span></p>
										</div>
									</div>
								</div>
							</div>
						);
					} else {
						return '';
					}
				}
				return (
					<div className="dms-table-box" style={{padding: '0'}}>
						{approveHtml()}
						<DmsTab className="white-bg no-border" options={['详情']} defaultKey={0}></DmsTab>
						<div className="tax_detail">
							<div className="com_detail">
								<div>
									<p><label>单位名称</label><span>{detailData.companyName}</span></p>
									<p><label>纳税人识别码</label><span>{detailData.taxpayerCode}</span></p>
									<p><label>注册电话</label><span>{detailData.phone}</span></p>
									<p><label>申请人</label><span>{detailData.userName}</span></p>
								</div>
								<div>
									<p><label>注册地址</label><span>{detailData.address}</span></p>
									<p><label>开户银行</label><span>{detailData.bankName}</span></p>
									<p><label>银行卡号</label><span>{detailData.bankAccount}</span></p>
									<p><label>创建时间</label><span>{detailData.createdDate}</span></p>
								</div>
							</div>
						</div>
						<DmsTab className="white-bg no-border" options={['增值委托书']} defaultKey={0}></DmsTab>
						<div className="dms-table-box">
							<img style={{width:'200px',height: '200px',cursor:'pointer'}} onClick={self.openImg.bind(this, config.server + detailData.filePath)} src={config.server + detailData.fileCompressPath} alt="" />
						</div>
					</div>
				);
			} else {
				let approveHtml = function () {
					if (detailData.status == 1 || detailData.status == 0) {
						return (
							<div>
								<DmsTab className="white-bg no-border" options={['审核信息']} defaultKey={0}></DmsTab>
								<div className="tax_detail">
									<div className="com_detail">
										<div>
											<p><label>申请人</label><span>{detailData.applyName}</span></p>
											<p><label>审核人</label><span>{detailData.auditName}</span></p>
											<p><label>审核意见</label><span>{detailData.auditOpinion}</span></p>
										</div>
										<div>
											<p><label>申请时间</label><span>{detailData.applyDate}</span></p>
											<p><label>审核时间</label><span>{detailData.auditDate}</span></p>
											<p><label>备注</label><span>{detailData.auditRemark}</span></p>
										</div>
									</div>
								</div>
							</div>
						);
					} else {
						return '';
					}
				}
				return (
					<div className="dms-table-box" style={{padding: '0'}}>
						{approveHtml()}
						<DmsTab className="white-bg no-border" options={['详情']} defaultKey={0}></DmsTab>
						<div className="tax_detail">
							<div className="com_detail">
								<div>
									<p><label>渠道</label><span>{detailData.channelName}</span></p>
									<p><label>人员</label><span>{detailData.name}</span></p>
									<p><label>账号</label><span>{detailData.account}</span></p>
								</div>
								<div>
									<p><label>门店</label><span>{detailData.storeName}</span></p>
									<p><label>岗位</label><span>{detailData.postText}</span></p>
									<p><label>角色</label><span>{detailData.roleName}</span></p>
								</div>
							</div>
						</div>
					</div>
				);
			}
		}
		return <div>
			<DmsTab options={[routeParams.entityType==8 ? '增票' : '账号']} defaultKey={0}>
				<Button style={{background:'#d61518', color: '#fff',display: ((detailData.status==1 && routeParams.entityType==8) || (detailData.status==2 && routeParams.entityType==7))?'inline-block': 'none'}} onClick={self.showApproveModal.bind(self)}>审核</Button>
				<Button onClick={this.backTo.bind(this)}>返回</Button>
			</DmsTab>
			{detailHtml()}
			<Modal
				visible={visibleApprove}
				title="订单审核"
				onOk={this.handleApproveOk.bind(this)}
				onCancel={this.handleApproveCancel.bind(this)}
				width = {'80%'}
				footer={[
            <Button key="back" size="large" onClick={self.handleApproveCancel.bind(this)}>取消</Button>,
            <Button key="submit" type="primary" size="large" loading={loadingApprove} onClick={self.handleApproveOk.bind(this)}>
              确认
            </Button>
          ]}
			>
				<div className="approve_modal">
					<label>审核意见</label>
					<div>
						<Switch checkedChildren="同意" unCheckedChildren="拒绝" onChange={this.changeApproveFn.bind(this, 'auditOpinion')} checked={approveData.auditOpinion?true:false} />
					</div>
				</div>
				<div className="approve_modal" style={{marginTop: '20px'}}>
					<label>备注</label>
					<div>
						<Input.TextArea placeholder="请输入备注" value={approveData.auditRemark} onChange={this.changeApproveFn.bind(this, 'auditRemark')} autosize={{ minRows: 2, maxRows: 6 }} />
					</div>
				</div>
			</Modal>
		</div>
	}
}
;
export default returnOrderDetail;



// WEBPACK FOOTER //
// ./src/routes/message/detail.js